import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import axios from "axios";
import * as _ from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import { authService } from "./auth";
import MemberItem from "./commons/MemberItem";
import CleverTapUtils from "./commons/CleverTapUtils";

class PersonaCountryUserListPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            userListData: {},
            dataSuccess: false,
            pageSize: 12
        }
    }

    getUserList = (page, size, concatWithPrevious) => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/post/login/topcontributor?userId=${this.state.userData.userId}&type=${this.props.currentData?.type}&value=${this.props.currentData?.value}&page=${page}&size=${size}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        }).then((response) => {
            if (response && response.data && response.data.message === "Success!") {
                let pageData = response.data.body;
                if (concatWithPrevious && this.state.userListData && this.state.userListData.content) {
                    pageData.content = this.state.userListData.content.concat(pageData.content);
                }
                this.setState({
                    userListData: pageData,
                    dataSuccess: false
                })

                CleverTapUtils.eventClick({"Type": this.props.currentData?.value}, "Category List Viewed") ;
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                dataSuccess: false
            })
        });
    }

    fetchMoreUserList = () => {
        if (this.state.userListData && this.state.userListData.content && !this.state.userListData.page?.last) {
            this.setState({
                dataSuccess: true
            })
            let pageable = this.state.userListData?.page?.pageable;
            this.getUserList(pageable.pageNumber + 1, this.state.pageSize, true);
        }
    };

    componentDidMount() {
        this.getUserList(0, this.state.pageSize, false);
    }

    componentWillUnmount() {
        this.props.closeUserPopUp();
    }

    render() {
        const { userListData, dataSuccess } = this.state;
        const { currentData } = this.props;
        const parentnav = { height: '45px' }
        return (
            <div id={"personaCountryUserListPopUp"} className="modal fade dgpopup reqendorse userReactionListPopUp" tabIndex="-1" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div
                                className="similarAllpopWrap forwcontwrap"
                                style={{ maxWidth: "510px" }}
                            >
                                <div>
                                    <div className="similarAllpopHeader">
                                        <h2>{currentData?.type === "COUNTRY" ? currentData?.value : "Members"}</h2>
                                    </div>
                                    <div className={"similarAllpopBody"}>
                                        <Scrollbars
                                            onScroll={!dataSuccess && !userListData?.page?.last && this.fetchMoreUserList}
                                            className={"forwcontlistmain"}
                                            autoHide
                                            autoHeight
                                            autoHeightMin={0}
                                            autoHeightMax={322}
                                            universal={true}
                                            renderTrackHorizontal={(props) => (
                                                <div {...props} className="track-horizontal" />
                                            )}
                                            renderTrackVertical={(props) => (
                                                <div {...props} className="track-vertical" />
                                            )}
                                        >
                                            {userListData?.content?.length > 0 && (
                                                <InfiniteScroll
                                                    dataLength={userListData?.content.length}
                                                    loadMore={this.fetchMoreUserList.bind(this)}
                                                    hasMore={!dataSuccess && !userListData?.page?.last}
                                                    height={322}
                                                >
                                                    {userListData.content.map((data, index) => {
                                                        return (
                                                            <MemberItem item={data} key={data.userId} />
                                                        );
                                                    })}
                                                </InfiniteScroll>
                                            )}
                                            {userListData?.content?.length === 0 &&
                                                <div className="zdata">
                                                    <div className="desc">
                                                        <h4>No data available.</h4>
                                                    </div>
                                                </div>
                                            }

                                        </Scrollbars>
                                    </div>
                                </div>
                                <div className="forwcontwrapbott">
                                    <div>
                                        <button className="butt btnsecondary close" onClick={(e) => { this.props.closeUserPopUp() }}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PersonaCountryUserListPopUp;